import React, { FC } from 'react';
import { PulseLoader } from 'react-spinners';

const loaderStyle = {
  width: '47px',
  height: '32px',
  lineHeight: '32px',
  margin: '5px 0',
};

interface LoaderProps {
  display: boolean;
}

const Loader: FC<LoaderProps> = (loaderProps: LoaderProps) => {
  const { display } = loaderProps;

  return display ? (
    <div style={loaderStyle}>
      <PulseLoader size={8} color={'#019ada'} />
    </div>
  ) : null;
};

export default Loader;
